/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RoutePath } from "../../routes/routePath";
import NotFound from "../../components/notFound";
import StepListingSkeleton from "../../utils/skeleton/stepListingSkeleton";
import userGlobalConfig from "../../utils/constants/globalConfig";
import ImagesUrl from "../../utils/constants/images";
import CustomModal from "../../components/customModal/customModal";
import { useFormik } from "formik";
import {
  addReviewImgInitialValues,
  addReviewImgValidationSchema,
} from "../../utils/validations/review";
import usePut from "../../hooks/usePut";
import ENDPOINTS from "../../services/endPoints";
import QUERY_KEYS from "../../services/queryKeys";
import { toast } from "react-toastify";

const ReviewList = ({
  subStepClick,
  reviewStepData,
  isLoadingReviewStep,
  refetchReviewList,
  reviewSkillID,
  reviewImage,
  refetchReviewListSkill,
}) => {
  const [reviewImgModal, setReviewImgModal] = useState({
    title: "",
    data: {},
    open: false,
    type: "",
    actionTitle: "",
    onConfirm: null,
  });
  const [uploadImg, setUploadImg] = useState(null);
  const uploadImageRef = useRef(null);
  const nav = useNavigate();
  const viewReviewStepDetail = (item, value) => {
    nav(RoutePath.REVIEW_DETAIL.path, {
      state: { headerName: RoutePath.REVIEW_DETAIL.title },
    });
    localStorage.setItem(userGlobalConfig.STEP_ID, JSON.stringify(item?._id));
    localStorage.setItem(
      userGlobalConfig.SUB_STEP_ID,
      JSON.stringify(value?._id)
    );
  };
  const { mutateAsync: editSkillMutateAsync, isLoading: isLoadingEditSkill } =
    usePut(ENDPOINTS.EDIT_REVIEW_IMAGE, QUERY_KEYS.EDIT_REVIEW_IMAGE_QUERY_KEY);
  const onChangeFile = (target) => {
    const selectedFile = target.files[0];
    setUploadImg(URL.createObjectURL(selectedFile));
    setFieldValue("reviewImage", selectedFile);
    target.value = "";
  };
  const handleSelectUploadImage = () => {
    if (uploadImageRef.current) {
      uploadImageRef.current.click();
    }
  };
  const handelRemoveUploadImg = () => {
    setUploadImg(null);
    setFieldValue("reviewImage", "");
  };
  const {
    errors,
    handleBlur,
    handleChange,
    touched,
    resetForm,
    handleSubmit,
    values,
    setFieldValue,
  } = useFormik({
    initialValues: addReviewImgInitialValues,
    validationSchema: addReviewImgValidationSchema,
    onSubmit: async () => {
      const formData = new FormData();
      formData.append("_id", reviewSkillID);
      formData.append("image", values?.reviewImage);
      try {
        const response = await editSkillMutateAsync(formData);
        if (response.statusCode === 200) {
          toast.success(response?.message);
          handleCloseReviewImgModal();
          resetForm();
          refetchReviewListSkill();
        } else {
          toast.error(response?.message);
        }
      } catch (error) {
        toast.error(error.response.data.message);
      }
    },
  });
  const handleAddReviewModalOpen = (type, data) => {
    if (type === "Add") {
      setReviewImgModal({
        open: true,
        title: "Add Review Image",
        actionTitle: "Add",
        type: type,
        onConfirm: handleSubmit,
        data: {},
      });
    } else if (type === "edit") {
      setReviewImgModal({
        open: true,
        title: "Edit Review Image",
        actionTitle: "Edit",
        type: type,
        onConfirm: handleSubmit,
        data: { data },
      });
    } else return null;
  };
  const returnReviewModal = () => {
    if (reviewImgModal.type === "Add") {
      return (
        <CustomModal
          open={reviewImgModal.open}
          title={reviewImgModal.title}
          actionTitle={reviewImgModal.actionTitle}
          cancelTitle="Cancel"
          actionButtonClass="bg-danger"
          onConfirm={reviewImgModal.onConfirm}
          isLoading={false}
          onClose={handleCloseReviewImgModal}
        >
          <div>
            <div className="drag-input-field mt-3">
              <label> Upload Image </label>
              <input
                type="file"
                accept="image/*"
                name="reviewImage"
                onBlur={handleBlur}
                onChange={({ target }) => {
                  onChangeFile(target);
                }}
                ref={uploadImageRef}
              />
              {values?.reviewImage?.length === 0 ? (
                <label className="m-0" onClick={handleSelectUploadImage}>
                  <span className="upload-text">
                    <i className="fa-solid fa-cloud-arrow-up" />
                    Upload image
                  </span>
                </label>
              ) : (
                <div className="position-relative border-1 border border-gray rounded-2 d-flex justify-content-center p-2">
                  <img
                    src={uploadImg === null ? values.reviewImage : uploadImg}
                    style={{
                      height: "200px",
                      width: "200px",

                      objectFit: "contain",
                      borderRadius: "5px",
                      border: "solid 1px #8080808a",
                    }}
                    alt="..."
                  />
                  <button
                    className="removeimg"
                    type="button"
                    onClick={() => handelRemoveUploadImg()}
                  >
                    X
                  </button>
                </div>
              )}
            </div>
            {touched.reviewImage && errors.reviewImage && (
              <p className="error" style={{ marginTop: "4px" }}>
                {errors.reviewImage}
              </p>
            )}
          </div>
        </CustomModal>
      );
    } else if (reviewImgModal.type === "edit") {
      return (
        <CustomModal
          open={reviewImgModal.open}
          title={reviewImgModal.title}
          actionTitle={reviewImgModal.actionTitle}
          cancelTitle={"Cancel"}
          actionButtonClass={"bg-danger"}
          onConfirm={reviewImgModal.onConfirm}
          isLoading={false}
          onClose={handleCloseReviewImgModal}
        >
          <div>
            <div className="drag-input-field mt-3">
              <label> Upload Image </label>
              <input
                type="file"
                accept="image/*"
                name="reviewImage"
                onBlur={handleBlur}
                onChange={({ target }) => {
                  onChangeFile(target);
                }}
                ref={uploadImageRef}
              />
              {values?.reviewImage?.length === 0 ? (
                <label className="m-0" onClick={handleSelectUploadImage}>
                  <span className="upload-text">
                    <i className="fa-solid fa-cloud-arrow-up" />
                    Upload image
                  </span>
                </label>
              ) : (
                <div className="position-relative border-1 border border-gray rounded-2 d-flex justify-content-center p-2">
                  <img
                    src={uploadImg === null ? values.reviewImage : uploadImg}
                    style={{
                      height: "200px",
                      width: "200px",

                      objectFit: "contain",
                      borderRadius: "5px",
                      border: "solid 1px #8080808a",
                    }}
                    alt="..."
                  />
                  <button
                    className="removeimg"
                    type="button"
                    onClick={() => handelRemoveUploadImg()}
                  >
                    X
                  </button>
                </div>
              )}
            </div>
            {touched.reviewImage && errors.reviewImage && (
              <p className="error" style={{ marginTop: "4px" }}>
                {errors.reviewImage}
              </p>
            )}
          </div>
        </CustomModal>
      );
    } else return null;
  };
  const handleCloseReviewImgModal = () => {
    setReviewImgModal({
      open: false,
      data: {},
    });
    resetForm();
    setUploadImg(null);
  };
  useEffect(() => {
    if (!reviewImgModal.open) {
      setFieldValue("reviewImage", reviewImage || "");
      setUploadImg(reviewImage || null);
    }
  }, [reviewImage, reviewImgModal.open, setFieldValue]);

  return (
    <div className="card-body pt-4 p-3">
      <div className="row gy-4">
        {!reviewStepData ? null : (
          <>
            <h6 className=""> Review Image</h6>
            <div className="background_div">
              <img
                src={values?.reviewImage ? reviewImage : ImagesUrl.empty_image}
                height={200}
                width={200}
                style={{ borderRadius: "10px" }}
                alt="..."
              />
              {values?.reviewImage == "" ? (
                <a
                  title="Add"
                  className="btn btn-link text-dark px-3 mb-0 cursor-pointer"
                  style={{ right: "0", top: "10px", position: "absolute" }}
                  onClick={() => handleAddReviewModalOpen("Add")}
                >
                  <i
                    class="fa fa-plus-square fa-2x text-dark me-2"
                    aria-hidden="true"
                  ></i>
                </a>
              ) : (
                <a
                  title="Edit"
                  className="btn btn-link text-dark px-3 mb-0 cursor-pointer"
                  style={{ right: "0", top: "10px", position: "absolute" }}
                  onClick={() => handleAddReviewModalOpen("edit", reviewImage)}
                >
                  <i
                    class="fas fs-5 fa-pencil-alt text-dark me-2"
                    aria-hidden="true"
                  ></i>
                </a>
              )}
            </div>
          </>
        )}
        {isLoadingReviewStep ? (
          <StepListingSkeleton />
        ) : !reviewStepData ? (
          <NotFound content="Review Not Found" />
        ) : (
          reviewStepData?.map((item, index) => {
            return (
              <div className="col-12" key={index}>
                <h6 className="mt-4"> Review Step List</h6>
                <div className="steps-wrapper">
                  <div className="steps-heading">
                    <h2>Step {index + 1}</h2>
                  </div>
                  <div className="flex-wrap-outer">
                    <div className="flex-wrap-blk">
                      {item.substeps?.map((value, i) => {
                        return (
                          <div
                            className="steps-content-blk cursor-pointer"
                            onClick={() => viewReviewStepDetail(item, value)}
                            key={i}
                          >
                            <div className="steps-card-img ">
                              <img src={value?.image} alt="Image" />
                            </div>
                            <div className="steps-detail">
                              <h3>{value?.name}</h3>
                              <span className="points">{value?.points}</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <button
                      type="button"
                      className="addButton cursor-pointer  border border-success"
                      onClick={() => subStepClick("subStep", item)}
                    >
                      <div className="d-flex justify-content-center align-items-center flex-column h-100">
                        <h3 className="cursor-pointer">
                          <i class="fa-solid fa-square-plus"></i>
                        </h3>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
      {returnReviewModal()}
    </div>
  );
};

export default ReviewList;
